var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 171,
  height: 40,
  fill: "none",
  viewBox: "0 0 237 55"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M236.3 24.206a2.285 2.285 0 0 1 .7 1.678 2.28 2.28 0 0 1-.7 1.678 2.26 2.26 0 0 1-1.665.706 2.26 2.26 0 0 1-1.665-.706 2.3 2.3 0 0 1-.676-1.678 2.303 2.303 0 0 1 .676-1.678 2.27 2.27 0 0 1 1.665-.681 2.26 2.26 0 0 1 1.665.68m-.144 3.21a2.08 2.08 0 0 0 .603-1.532 2.13 2.13 0 0 0-1.299-2.007 2.1 2.1 0 0 0-.825-.158 2.03 2.03 0 0 0-1.496.633 2.15 2.15 0 0 0-.627 1.532 2.15 2.15 0 0 0 .627 1.532 2.05 2.05 0 0 0 1.496.633 2.06 2.06 0 0 0 1.521-.633m-.917-1.24.506.924h-.651l-.386-.778h-.29v.778h-.603v-2.432h.893a.86.86 0 0 1 .651.243.66.66 0 0 1 .266.56.77.77 0 0 1-.092.409.75.75 0 0 1-.294.296m-.821-.365h.29a.5.5 0 0 0 .265 0 .34.34 0 0 0 0-.219c0-.194 0-.292-.338-.292h-.265zM96.094 22.211a7.46 7.46 0 0 1 1.786 5.23v10.727h-4.465V27.757a3.64 3.64 0 0 0-.772-2.433 2.73 2.73 0 0 0-2.124-.85 2.95 2.95 0 0 0-2.413.997 4.55 4.55 0 0 0-.844 2.943v9.73h-4.465V27.733a3.65 3.65 0 0 0-.748-2.433 2.77 2.77 0 0 0-2.148-.851 2.92 2.92 0 0 0-2.413.997 4.28 4.28 0 0 0-.893 2.943v9.73h-4.464V20.703h4.464v1.849a5.4 5.4 0 0 1 2.09-1.867 5.37 5.37 0 0 1 2.737-.566 5.1 5.1 0 0 1 2.757.523 5.13 5.13 0 0 1 2.07 1.91 5.9 5.9 0 0 1 2.268-1.892 5.8 5.8 0 0 1 2.895-.54 6.1 6.1 0 0 1 2.63.428 6.1 6.1 0 0 1 2.197 1.517M117.547 20.752v17.416h-4.464v-1.946a5.73 5.73 0 0 1-2.25 1.904 5.7 5.7 0 0 1-2.89.528 6.3 6.3 0 0 1-2.538-.455 6.3 6.3 0 0 1-2.144-1.442 7.343 7.343 0 0 1-1.858-5.303V20.752h4.464v10.143a3.56 3.56 0 0 0 .942 2.651 3.3 3.3 0 0 0 2.413.924 3.55 3.55 0 0 0 2.751-1.07 4.5 4.5 0 0 0 1.037-3.235v-9.413zM126.114 12.725h-4.465v25.443h4.465zM136.152 25.057v7.297a1.833 1.833 0 0 0 .459 1.338 2.1 2.1 0 0 0 1.327.462q1.061.056 2.123 0v4.063c-2.189.51-4.488.199-6.467-.876a5.8 5.8 0 0 1-1.545-2.262 5.8 5.8 0 0 1-.337-2.725v-7.297h-3.017v-4.305h3.017v-4.865h4.44v4.865h3.909v4.305zM147.688 20.727h-4.464v17.44h4.464zM156.423 37.997a8.44 8.44 0 0 1-2.944-1.994 8.9 8.9 0 0 1-1.973-3 9 9 0 0 1-.633-3.544 9 9 0 0 1 .633-3.542 8.9 8.9 0 0 1 1.973-3 8.8 8.8 0 0 1 2.983-2.014 8.7 8.7 0 0 1 3.533-.638 8.83 8.83 0 0 1 4.609 1.216 8.1 8.1 0 0 1 3.137 3.26l-3.837 2.286a4 4 0 0 0-1.568-1.727 4.6 4.6 0 0 0-2.414-.608 4.413 4.413 0 0 0-3.306 1.338 4.9 4.9 0 0 0-1.327 3.43 4.75 4.75 0 0 0 1.327 3.405c.433.437.948.782 1.517 1.012.568.23 1.177.34 1.789.326a4.63 4.63 0 0 0 2.414-.608 3.8 3.8 0 0 0 1.568-1.703l3.885 2.238a8.7 8.7 0 0 1-3.064 3.284 8.85 8.85 0 0 1-4.61 1.24 9.4 9.4 0 0 1-3.571-.657M174.643 20.727h-4.464v17.44h4.464zM193.007 22.162a7.3 7.3 0 0 1 1.457 2.464c.319.91.455 1.875.402 2.839v10.703h-4.465V28.025a3.52 3.52 0 0 0-.941-2.652 3.33 3.33 0 0 0-2.413-.924 3.62 3.62 0 0 0-2.775 1.07 4.5 4.5 0 0 0-1.038 3.235v9.414h-4.464V20.752h4.464v1.946a5.8 5.8 0 0 1 2.263-1.905 5.7 5.7 0 0 1 2.901-.528 6.3 6.3 0 0 1 2.538.456 6.3 6.3 0 0 1 2.144 1.441M207.318 34.592a4.5 4.5 0 0 0 2.146-.394 4.54 4.54 0 0 0 1.715-1.357l3.596 2.092a8.6 8.6 0 0 1-3.284 2.85 8.53 8.53 0 0 1-4.245.871 9.3 9.3 0 0 1-3.715-.59 9.4 9.4 0 0 1-3.187-2.013 9 9 0 0 1-1.962-3.028 9.1 9.1 0 0 1-.62-3.563 9 9 0 0 1 .612-3.548 9 9 0 0 1 1.946-3.02 8.8 8.8 0 0 1 3.009-2.005 8.75 8.75 0 0 1 3.555-.622 8.2 8.2 0 0 1 3.417.633 8.25 8.25 0 0 1 2.857 1.994 9.24 9.24 0 0 1 2.413 6.568c.001.62-.056 1.239-.169 1.848h-13.055a4.5 4.5 0 0 0 1.809 2.544 4.43 4.43 0 0 0 3.017.74zm3.716-6.762a4.1 4.1 0 0 0-1.568-2.651 4.5 4.5 0 0 0-2.727-.876 4.6 4.6 0 0 0-2.968.924 4.4 4.4 0 0 0-1.545 2.603zM223.1 26.833c.714.324 1.458.577 2.22.754a22 22 0 0 1 2.631.851 5.4 5.4 0 0 1 2.244 1.678c.62.862.942 1.904.917 2.968a4.89 4.89 0 0 1-2.003 4.135 8.13 8.13 0 0 1-4.971 1.435 7.2 7.2 0 0 1-4.268-.914 7.28 7.28 0 0 1-2.972-3.22l3.886-2.214c.21.718.662 1.34 1.279 1.758s1.36.604 2.099.528c1.593 0 2.413-.51 2.413-1.508 0-.462-.289-.851-.917-1.143a17 17 0 0 0-2.22-.779 18.5 18.5 0 0 1-2.63-.875 5.3 5.3 0 0 1-2.22-1.654 4.28 4.28 0 0 1-.917-2.846 4.89 4.89 0 0 1 1.834-4.014 7.37 7.37 0 0 1 4.681-1.46 7.87 7.87 0 0 1 3.837.95 6.93 6.93 0 0 1 2.727 2.748l-3.789 2.092a2.9 2.9 0 0 0-1.105-1.342 2.86 2.86 0 0 0-1.67-.458 2.66 2.66 0 0 0-1.448.39 1.24 1.24 0 0 0-.555 1.045c0 .462.29.851.917 1.143"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__b)",
  d: "M42.496.125a4.97 4.97 0 0 0-2.522.706 5 5 0 0 0-1.821 1.896L27.052 24.62l15.01 29.554h12.066V.125z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__c)",
  d: "M0 54.125h12.066L27.1 24.57 16 2.678A4.85 4.85 0 0 0 14.207.75a4.8 4.8 0 0 0-2.527-.7H.048"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__d)",
  d: "M12.018 54.125h30.044L27.028 24.376z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__e)",
  d: "M142.717 15.887c0 1.52 1.231 2.773 2.751 2.773s2.751-1.254 2.751-2.773-1.232-2.773-2.751-2.773c-1.52 0-2.751 1.253-2.751 2.773"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__f)",
  d: "M169.647 15.887c0 1.52 1.232 2.773 2.751 2.773 1.52 0 2.752-1.254 2.752-2.773s-1.232-2.773-2.752-2.773-2.751 1.253-2.751 2.773"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__b",
  x1: 53.088,
  x2: 53.088,
  y1: 17.881,
  y2: 53.151,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#14D7CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#02A8D7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__c",
  x1: 9.653,
  x2: 9.653,
  y1: -0.362,
  y2: 53.152,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9D500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "orange"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__d",
  x1: 27.052,
  x2: 27.052,
  y1: 29.071,
  y2: 58.503,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F16C8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#E65494"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C63894"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__e",
  x1: -6475.72,
  x2: -6463.17,
  y1: -7694.63,
  y2: -7694.63,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F16C8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#E65494"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C63894"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__f",
  x1: 166.939,
  x2: 172.441,
  y1: 12.847,
  y2: 12.847,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00ABBF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#00A3C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0094C5"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .125h237v54H0z"
})))));
export default SvgLogo;